var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProgressTag = function SvgProgressTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;}.b{clip-path:url(#a);}.c{stroke:#171926;stroke-width:0.3px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 13,
    height: 13,
    transform: "translate(0.029 -0.191)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-0.029 0.191)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.741 0.347)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 11.006)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M20.713,54.917H12.459a.459.459,0,1,1,0-.917h8.254a.459.459,0,0,1,0,.917Z",
    transform: "translate(-12 -54)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.917 2.293)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M22.879,23.337a.458.458,0,0,1-.459-.458c0-1.256-1.272-1.98-2.463-2.56-.158-.077-.326-.155-.5-.236C18,19.4,16,18.473,16,16.459A.459.459,0,0,1,16.458,16h0a.459.459,0,0,1,.459.458c0,1.43,1.556,2.154,2.928,2.794.179.083.352.164.514.243,1.04.507,2.976,1.449,2.978,3.383a.459.459,0,0,1-.458.459Z",
    transform: "translate(-16 -16)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.917 2.293)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M16.459,23.337h0A.459.459,0,0,1,16,22.878c0-2.014,2-2.944,3.457-3.624.174-.081.342-.159.5-.236,1.191-.58,2.461-1.3,2.463-2.56A.459.459,0,0,1,22.879,16h0a.459.459,0,0,1,.458.459c0,1.934-1.938,2.877-2.978,3.383-.163.079-.335.16-.514.243-1.371.639-2.925,1.363-2.927,2.793A.459.459,0,0,1,16.459,23.337Z",
    transform: "translate(-16 -16)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.337 8.713)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M44.459,47.21A.459.459,0,0,1,44,46.751V44.459a.459.459,0,0,1,.917,0v2.293A.459.459,0,0,1,44.459,47.21Z",
    transform: "translate(-44 -44)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.917 8.713)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M16.459,47.21A.459.459,0,0,1,16,46.751V44.459a.459.459,0,0,1,.917,0v2.293A.459.459,0,0,1,16.459,47.21Z",
    transform: "translate(-16 -44)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.337)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M44.459,9.21A.459.459,0,0,1,44,8.751V6.459a.459.459,0,1,1,.917,0V8.751A.459.459,0,0,1,44.459,9.21Z",
    transform: "translate(-44 -6)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.917)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M16.459,9.21A.459.459,0,0,1,16,8.751V6.459a.459.459,0,0,1,.917,0V8.751A.459.459,0,0,1,16.459,9.21Z",
    transform: "translate(-16 -6)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M20.713,6.917H12.459a.459.459,0,1,1,0-.917h8.254a.459.459,0,0,1,0,.917Z",
    transform: "translate(-12 -6)"
  })))));
};
export default SvgProgressTag;